<template>
  <TextField
    id="mealplan-name"
    :name="name"
    :label="translate(`${LOCALE_PREFIX}.form.planName`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.planNamePlaceholder`)"
    required
    :disabled="disabled"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../../enums';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

defineProps({
  name: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
</script>
